import {
  CREATE_UTILITY_REQUEST,
  CREATE_UTILITY_REQUEST_SUCCESS,
  CREATE_UTILITY_REQUEST_ERROR,
  CREATE_UTILITY_REQUEST_EMPTY,
} from '../../actions.js';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const CreateUtilityRequest = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_UTILITY_REQUEST:
      return { ...state, loading: true, data: null, error: null };

    case CREATE_UTILITY_REQUEST_SUCCESS:
      return { ...state, loading: false, data: action.payload };

    case CREATE_UTILITY_REQUEST_ERROR:
      return { ...state, loading: false, error: action.payload };

    case CREATE_UTILITY_REQUEST_EMPTY:
      return { ...initialState };

    default:
      return state;
  }
};

export default CreateUtilityRequest;
